'use strict';

import React, { useState, useEffect } from 'react';

const TextArea = ({
    className = 'el-labeled-input',
    textareaClassName = '',
    counterClassName = 'el-input-char-limit',
    maxLength,
    value,
    defaultValue = '', // fallback for when value in undefined
    onChange,
    ...props
}) => {
    const hasExternalValue = value !== undefined;

    const [internalValue, setInternalValue] = useState(defaultValue);

    useEffect(() => {
        if (hasExternalValue) {
            setInternalValue(value);
        }
    }, [value, hasExternalValue]);

    const handleChange = (e) => {
        let inputValue = e.target.value;
        if (maxLength && inputValue.length > maxLength) {
            inputValue = inputValue.slice(0, maxLength);
        }

        if (!hasExternalValue) {
            setInternalValue(inputValue);
        }

        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div className={className} data-error={internalValue.length >= maxLength}>
            <textarea
                {...props}
                className={textareaClassName}
                value={internalValue}
                onChange={handleChange}
            />
            {maxLength && (
                <p className={counterClassName}>
                    {internalValue.length}/{maxLength}
                </p>
            )}
        </div>
    );
};

export default TextArea;
